/* eslint-disable */ import { memoEval, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const lynxProfessionalOutdoorRefrigeratorWithGlassDoorW24Components = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'REFRIGERATOR_LN24REFG',
            dimensionUnit: 'inch'
        })))
];

//# sourceMappingURL=lynx-professional-outdoor-refrigerator-with-glass-door-w-24.js.map